"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _native = _interopRequireDefault(require("styled-components/native"));
var _NativeIcon = _interopRequireDefault(require("./NativeIcon"));
var _lodash = require("lodash");
var _colorHelper = require("./helpers/color-helper");
var _Text = _interopRequireDefault(require("../SharedComponents/Typography/Text"));
var _color = _interopRequireDefault(require("../Components/styles/color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var getBackgroundColor = function getBackgroundColor(props) {
  if (props.darkTheme) {
    return props.color;
  }
  return "".concat(props.color, "16");
};

/* background-color prop is appended a 16 to specify an opacity of 10% because when you use
   opacity: 0.1 all the children inherit it and cannot be overridden */
/* istanbul ignore next */
var CircleContainer = _native["default"].TouchableOpacity.withConfig({
  displayName: "CircleContainer",
  componentId: "sc-pvl6sr-0"
})(["width:", "px;height:", "px;border-radius:", "px;background-color:", ";display:flex;justify-content:center;align-items:center;"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size / 2;
}, function (props) {
  return getBackgroundColor(props);
});
/* istanbul ignore next */
var NativeImage = _native["default"].Image.withConfig({
  displayName: "NativeImage",
  componentId: "sc-pvl6sr-1"
})(["border-radius:", "px;width:100%;height:100%;"], function (props) {
  return props.size / 2;
});
function Avatar(props) {
  var userName = props.userName,
    size = props.size,
    icon = props.icon,
    fontSize = props.fontSize,
    thumbnail = props.thumbnail,
    appBrandColor = props.appBrandColor,
    contentType = props.contentType,
    onClick = props.onClick,
    onPress = props.onPress,
    iconSize = props.iconSize,
    darkTheme = props.darkTheme,
    customCircleColor = props.customCircleColor,
    spin = props.spin;
  var getInitials = function getInitials(userName, color, fontSize) {
    var initials = '';
    if ((0, _lodash.isEmpty)(userName)) initials = '';
    var nameParts = userName.trim().split(' ');
    if (nameParts.length === 1) initials = nameParts[0].substring(0, 1);else initials = nameParts[0].substring(0, 1) + nameParts[nameParts.length - 1].substring(0, 1);
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      fontColor: color,
      textSize: fontSize,
      allowFontScaling: false,
      text: initials
    });
  };
  var getIcon = function getIcon(size, icon, color, iconSize) {
    return /*#__PURE__*/_react["default"].createElement(_NativeIcon["default"], {
      iconName: icon,
      color: color,
      size: iconSize || size * 0.65,
      spin: spin || false
    });
  };
  var getImage = function getImage(size, thumbnail) {
    return /*#__PURE__*/_react["default"].createElement(NativeImage, {
      size: size,
      source: {
        uri: thumbnail
      }
    });
  };
  var circleInnerElement;
  var _getContentIconColor = (0, _colorHelper.getContentIconColor)(contentType),
    circleColor = _getContentIconColor.circleColor,
    contentIcon = _getContentIconColor.contentIcon;
  var initialColor = darkTheme ? _color["default"].white : circleColor || appBrandColor;
  var circleIcon = contentIcon || icon;
  var disabled = !(onClick || onPress);
  if (thumbnail) {
    circleInnerElement = getImage(size, thumbnail);
  } else {
    circleInnerElement = userName ? getInitials(userName, initialColor, fontSize) : circleIcon ? getIcon(size, circleIcon, initialColor, iconSize) : getImage(size, thumbnail);
  }
  return /*#__PURE__*/_react["default"].createElement(CircleContainer, {
    testID: "Avatar",
    activeOpacity: 0.9,
    onClick: onClick,
    onPress: onPress,
    disabled: disabled,
    darkTheme: darkTheme,
    color: customCircleColor || circleColor || appBrandColor,
    size: size
  }, circleInnerElement);
}
var _default = Avatar;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(getBackgroundColor, "getBackgroundColor", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeAvatar.js");
  reactHotLoader.register(CircleContainer, "CircleContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeAvatar.js");
  reactHotLoader.register(NativeImage, "NativeImage", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeAvatar.js");
  reactHotLoader.register(Avatar, "Avatar", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeAvatar.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeAvatar.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();